module.exports = __webpack_public_path__ + "static/media/img_landing15.1c3089a8.png";